import { Link } from "react-router-dom"
import React, { useCallback } from "react"
import { getTrackRoute } from "../routes"
import useTrackStatus from "../../modules/user/hooks/use-track-status"
import useRestartTrack from "../../modules/user/hooks/use-restart-track"

type Props = {
    track: TrackData
}

const TrackLink: React.FunctionComponent<Props> = ({ track }) => {

    const status = useTrackStatus(track.id);

    const restartTrack = useRestartTrack();

    const onClick = useCallback((trackId: TrackId) => {
        restartTrack(trackId)
    }, [restartTrack])

    return (
        <>
            {status === 'active' && <Link className={`track-link ${status}`} to={getTrackRoute(track.id)}><span>{track.title}</span></Link>}
            {status === 'lost' && <Link className={`track-link ${status}`} to={getTrackRoute(track.id)} onClick={() => onClick(track.id)}><span>{track.title}</span></Link>}
            {status === 'completed' && <span className={`track-link ${status}`}><span>{track.title}</span></span>}
        </>
    )
}

export default TrackLink;
